import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { map, tap } from 'rxjs/operators';
import { getAccountDetailsStatus } from '@aaa/emember/store-account';
import { AccountStatus } from '../../../types';
import { Pages } from '../../../constants/pages';

export const isMembershipStatusAllowed =
  (allowStatus: AccountStatus | AccountStatus[]): CanActivateChildFn =>
  () => {
    const store = inject(Store<AppStore>);
    const router = inject(Router);

    return store.select(getAccountDetailsStatus).pipe(
      map((status) =>
        Array.isArray(allowStatus) ? allowStatus.includes(status as AccountStatus) : allowStatus === status,
      ),
      tap((allow) => !allow && router.navigateByUrl(Pages.accountMembership)),
    );
  };

export default isMembershipStatusAllowed;
